import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=7b24a2a1&scoped=true&"
import script from "./AdminComponent.vue?vue&type=script&lang=js&"
export * from "./AdminComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminComponent.vue?vue&type=style&index=0&id=7b24a2a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24a2a1",
  null
  
)

export default component.exports